import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";


export function loadRentMachineCategoriesSuccess(categories) {
    return {type: types.LOAD_RENT_MACHINE_CATEGORIES_SUCCESS, categories};
}

export function createRentMachineCategorySuccess(category) {
    return {type: types.CREATE_RENT_MACHINE_CATEGORY_SUCCESS, category};
}

export function getRentMachineCategorySuccess(category) {
    return {type: types.GET_RENT_MACHINE_CATEGORY_SUCCESS, category};
}

export function updateUpdateRentMachineCategorySuccess(category) {
    return {type: types.UPDATE_RENT_MACHINE_CATEGORY_SUCCESS, category};
}

export function deleteRentMachineCategorySuccess(id) {
    return {type: types.DELETE_DELETE_RENT_MACHINE_CATEGORY_SUCCESS, id};
}

export function resetRentMachineCategory() {
    return { type: types.RESET_RENT_MACHINE_CATEGORY };
}

export function getRentMachineCategory(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('rent-machine/categories', id).then(category => {
            dispatch(getRentMachineCategorySuccess(category))
        }).catch(error => {
            throw error;
        });
    }
}

export function getRentMachineCategories() {
    return function (dispatch) {
        return PrivateAPIResource.get('rent-machine/categories').then(categories => {
            dispatch(loadRentMachineCategoriesSuccess(categories))
        }).catch(error => {
            throw error;
        });
    }
}

export function saveRentMachineCategory(category) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('rent-machine/categories/add-category', category)
            .then(category => {
                dispatch(createRentMachineCategorySuccess(category));
            })
            .catch(error => {
                throw error;
            });
    }
}

export function updateRentMachineCategory(category, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('rent-machine/categories/update-category', id, category)
            .then(category => {
                dispatch(updateUpdateRentMachineCategorySuccess(category));
            })
            .catch(error => {
                throw error;
            })
    }
}

export function deleteRentMachineCategory(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('rent-machine/categories/remove-category', id)
            .then(() => {
                dispatch(deleteRentMachineCategorySuccess(id));
            })
            .catch(error => {
                throw error;
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/rent-machine/rentMachineCategoryActions.js